import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Chip, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import config from "./config";
import AsyncSearchField from "./AsyncSearchField";
import DiscountsTable from "./DiscountsTable";
import { useNavigate } from "react-router-dom";

function Management() {
  const [webpayDevices, setWebpayDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();
  const [editRow, setEditRow] = useState(null);
  const [editBackup, setEditBackup] = useState(null);
  const [rowIdToBeDeleted, setRowIdToBeDeleted] = useState(null);
  const [row, setRow] = useState(null);
  const [lanesOptions, setLanesOptions] = useState([]);
  const [placeDevices, setPlaceDevices] = useState([]);
  const [currentPlaceId, setCurrentPlaceId] = useState(null);
  const [isOpenDiscountsTable, setIsOpenDiscountsTable] = useState(false);
  const [isOpenSendSubscriptionDialog, setIsOpenSendSubscriptionDialog] = useState(false);
  const [comaxSettingsOpen,  setComaxSettingsOpen]  = useState(false);
  const [comaxSettings,      setComaxSettings]      = useState({});
  const [subscriptionAmount, setSubscriptionAmount] = useState(0);
  const [carNum, setCarNum] = useState("");
// Open the modal and load settings

  const handleSendSubsriptionAmount = ()=> {
    console.log(row, subscriptionAmount);
    setIsOpenSendSubscriptionDialog(false);
    fetch(
        `${config.rtc.serverUrl}/send-subscription-payment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",     // ← important
          },
          body: JSON.stringify({amount: subscriptionAmount, lp: carNum, deviceName: row.computername, deviceGuid: row.laneid}),
        },
    ).then((res) => {
      if (!res.ok) { alert('שגיאה בשליחת דמי מנוי'); return;}
      return res.json();
    })
        .then((data) => {
          alert('דמי מנוי נשלחו בהצלחה');
        });
  }

  const handleOpenComaxSettings = (placeId) => {
    fetch(
        `${config.app.serverUrl}/getcomaxdiscount?token=${localStorage.getItem(
            'googleAuthToken'
        )}&placeId=${placeId}`
    )
        .then((res) => {
          if (!res.ok) throw new Error('Failed to load Comax settings');
          return res.json();
        })
        .then((data) => {
          // if the server returns `null` or {} (no discount), give one blank row
          const defaultRow = {
            id: null,
            discountType: '',
            discountVal: 0,
            placeId,
          };

          const rows =
              data && data.discountType !== undefined
                  ? data     // wrap the real object
                  : defaultRow;

          setComaxSettings(rows);
          setComaxSettingsOpen(true);
        })
        .catch((err) => {
          console.error(err);
          // still open the modal with a blank row
          setComaxSettings([{ id: null, discountType: '', discountVal: 0, placeId }]);
          setComaxSettingsOpen(true);
        });
  };
// Close without saving
  const handleCloseComaxSettings = () => {
    setComaxSettingsOpen(false);
  };

// Update a single cell in the Comax table
  const handleComaxChange = (idx, field, value) => {
    setComaxSettings(prev => {
      const next = [...prev];
      next[idx] = { ...next[idx], [field]: field === 'discountValue' ? Number(value) : value };
      return next;
    });
  };

// Persist back to your save API
  const handleSaveComaxSettings = () => {
    // if (!comaxSettings.length) return;

    const row = comaxSettings;
    const payload = {
      placeId: currentPlaceId,
      discounts: [
        {
          discountType: row.discountType,
          discountValue: row.discountVal,
        },
      ],
    };

    const body = new URLSearchParams();
    body.append('data', JSON.stringify(payload));

    fetch(
        `${config.app.serverUrl}/savecomaxdiscount?token=${localStorage.getItem(
            'googleAuthToken'
        )}`,
        {
          method: 'POST',
          body: body,
        }
    )
        .then((res) => {
          if (!res.ok) throw new Error('Failed to save Comax settings');
          return res.json();
        })
        .then(() => {
          setComaxSettingsOpen(false);
          // optionally reload discounts table…
        })
        .catch((err) => console.error(err));
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [newPrefix, setNewPrefix] = useState("");
  const navigate = useNavigate();
  // const [prefixList, setPrefixList] = useState( []);
  const [isMaxLengthReached, setIsMaxLengthReached] = useState({
    lane_guid: false,
    computername: false,
    laneid: false,
    placeid: false,
    placeName: false,
    displayName: false,
    branchNum: false,
  });
  const [isMaxLengthReachedNewRow, setIsMaxLengthReachedNewRow] = useState({
    lane_guid: false,
    computername: false,
    laneid: false,
    placeid: false,
    placeName: false,
    displayName: false,
    branchNum: false,
  });

  const [newRow, setNewRow] = useState({
    lane_guid: "",
    computername: "",
    laneid: "",
    laneName: "",
    placeid: "",
    placeName: "",
    barcodeType: "rami levy",
    discountType: "time", // Default value
    withPayment: true,
    withQr: true,
    enableOverride: false,
    overrideDiscountType: "time",
    overrideDiscountValue: 0,
    active: true,
    branchNum: "",
    graceTimeOffset: 0,
    payment_discount: 2,
  });
  const [openAddRowDialog, setOpenAddRowDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({}); // State to store search filters

  const rowsPerPage = 8;

  const payplus_clients = [{ payplus_customer_name: "Ami Tests", payplus_customer_email: "ami@blueparking.co.il"}]

  // Update filters when input changes
  const handleFilterChange = (field, value) => {
    setFilters((prev) => {
      const updatedFilters = { ...prev };
      if (value) {
        updatedFilters[field] = value;
      } else {
        delete updatedFilters[field]; // Remove filter key if input is cleared
      }
      return updatedFilters;
    });
  };

  // Filter rows based on filters
  const filteredDevices = webpayDevices.filter((device) =>
    Object.keys(filters).every((field) =>
      device[field]
        ?.toString()
        .toLowerCase()
        .includes(filters[field]?.toLowerCase() || ""),
    ),
  );

  useEffect(() => {
    fetch(
      `${config.app.serverUrl}/getwebpaydevices?token=${localStorage.getItem("googleAuthToken")}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error loading devices");
        }
        return response.json();
      })
      .then((data) => {
        setWebpayDevices(data || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching devices:", error);
        setError("Error loading devices. Please try again.");
        setIsLoading(false);
        navigate('/login');
      });
  }, []);

  // useEffect(() => {
  //   console.log("webpayDevices", webpayDevices);
  // }, [webpayDevices]);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  // Calculate the devices to show on the current page
  const indexOfLastDevice = currentPage * rowsPerPage;
  const indexOfFirstDevice = indexOfLastDevice - rowsPerPage;
  const currentDevices = filteredDevices.slice(
    indexOfFirstDevice,
    indexOfLastDevice,
  );
  function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16).toUpperCase();
      },
    );
  }

  const handleEditChange = (e, field) => {
    const row = webpayDevices.find((device) => device?.id === editRow);
    if (field === "active" || field === "withPayment" || field === "enableOverride" || field === 'withQr') {
      if (e.target.value === "No") {
        row[field] = 0;
      } else {
        row[field] = 1;
      }
    } else if (field === "branchNum") {
      row[field] = e.target.value;
      if (e.target.value.length <= 4) {
        isMaxLengthReached[field] = false;
        setIsMaxLengthReached({ ...isMaxLengthReached });
      } else {
        isMaxLengthReached[field] = true;
        setIsMaxLengthReached({ ...isMaxLengthReached });
      }
    } else {
      if (e.target.value.length <= 45) {
        row[field] = e.target.value;
        isMaxLengthReached[field] = false;
        setIsMaxLengthReached({ ...isMaxLengthReached });
        if (field === "laneid") {
          row.computername = placeDevices?.filter((device) =>
            device.lanes?.includes(row.laneid),
          )[0]?.id;
          row.laneName = lanesOptions.find(
            (lane) => lane?.id === row?.laneid,
          ).name;
        }
      } else {
        isMaxLengthReached[field] = true;
        setIsMaxLengthReached({ ...isMaxLengthReached });
      }
    }
    setWebpayDevices([...webpayDevices]);
  };

  const handleEditNewField = async (e, field) => {
    if (field === "branchNum") {
      newRow[field] = e.target.value;
      setNewRow({ ...newRow });
      if (e.target.value.length <= 4) {
        isMaxLengthReachedNewRow[field] = false;
        setIsMaxLengthReachedNewRow({ ...isMaxLengthReachedNewRow });
      } else {
        isMaxLengthReachedNewRow[field] = true;
        setIsMaxLengthReachedNewRow({ ...isMaxLengthReachedNewRow });
      }
    }   else  if (field === "active" || field === "withPayment" || field === "enableOverride" || field === 'withQr') {
      if (e.target.value === "No") {
        newRow[field] = 0;
      } else {
        newRow[field] = 1;
      }
      setNewRow({ ...newRow });
    }

    else if (e.target.value.length < 45) {
      newRow[field] = e.target.value;
      if (field === "laneid") {
        newRow.computername = placeDevices?.filter((device) =>
          device?.lanes?.includes(newRow.laneid),
        )[0]?.id;
        newRow.laneName = lanesOptions.find(
          (lane) => lane?.id === newRow?.laneid,
        )?.name;
      }
      setNewRow({ ...newRow });
      isMaxLengthReachedNewRow[field] = false;
      setIsMaxLengthReachedNewRow({ ...isMaxLengthReachedNewRow });
    } else {
      isMaxLengthReachedNewRow[field] = true;
      setIsMaxLengthReachedNewRow({ ...isMaxLengthReachedNewRow });
    }
  };

  const fetchPlaceInfo = async (row) => {
    const data = await fetch(
      `${config.app.serverUrl}/api/get-place-info/${row ? row.placeid : newRow.placeid}`
    );
    const dataJson = await data.json();
    setLanesOptions(
      dataJson?.data?.place?.lanes?.filter(
        (lane) =>
          lane.direction.toUpperCase() === "OUT" &&
          lane?.name.toUpperCase().includes("VPOF"),
      ),
    );
    setPlaceDevices(dataJson?.data?.place?.devices);
  };

  useEffect(() => {
    (async function f() {
      if (newRow.placeid) await fetchPlaceInfo();
    })();
  }, [newRow.placeid]);

  const handleSaveEdit = () => {
    const updatedRow = webpayDevices.find((device) => device?.id === editRow);

    setIsLoading(true);
    const data = new URLSearchParams();
    data.append("data", JSON.stringify(updatedRow));
    fetch(
      `${config.app.serverUrl}/updatewebpaydevice/${updatedRow.id}?token=${localStorage.getItem("googleAuthToken")}`,
      {
        method: "POST",
        body: data,
      },
    )
      .then((response) => {
        if (!response.ok) {
          // throw new Error("session expired");
          navigate('/login');
        }
        setEditRow(null);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setIsLoading(false);
      });
  };

  const handleCancelEdit = () => {
    // Restore the original state of the edited row
    const updatedData = [...webpayDevices];
    const index = updatedData.findIndex(
      (device) => device?.id === editBackup?.id,
    );
    updatedData[index] = editBackup;
    setWebpayDevices([...updatedData]);
    setEditRow(null);
    setEditBackup(null); // Clear the backup
  };

  const handleDelete = (id) => {
    setIsLoading(true);

    fetch(
      `${config.app.serverUrl}/deletewebpaydevice/${id}?token=${localStorage.getItem("googleAuthToken")}`,
      {
        method: "GET",
      },
    )
      .then(() => {
        const updatedDevices = webpayDevices.filter(
          (device) => device?.id !== id,
        );
        setWebpayDevices(updatedDevices);

        // Check if we need to adjust the page
        const totalPages = Math.ceil(updatedDevices.length / rowsPerPage);

        // If the current page is now greater than the total pages, reduce the page number
        if (currentPage > totalPages && totalPages > 0) {
          setCurrentPage(totalPages);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setError("Error deleting device: " + error.message);
        setIsLoading(false);
      });
  };

  const handleAddNewRow = () => {
    setIsLoading(true);
    const data = new URLSearchParams();
    data.append("data", JSON.stringify(newRow));
    fetch(
      `${config.app.serverUrl}/addwebpaydevice?token=${localStorage.getItem("googleAuthToken")}`,
      {
        method: "POST",
        body: data,
      },
    )
      .then((response) => {
        if (!response.ok) {
          // throw new Error("Error. session expired");
          navigate('/login');
        } else {
          return response.json();
        }
      })
      .then((addedRow) => {
        setWebpayDevices((prevDevices) => [...prevDevices, addedRow]);
        const itemsPerPage = 8;
        const totalItemsAfterAdd = webpayDevices.length;
        const totalPages = Math.ceil(totalItemsAfterAdd / itemsPerPage);
        if (
          totalItemsAfterAdd % itemsPerPage === 0 &&
          currentPage === Math.floor(totalItemsAfterAdd / itemsPerPage)
        ) {
          setCurrentPage(totalPages + 1);
        } else if (
          totalItemsAfterAdd % itemsPerPage !== 0 &&
          currentPage < totalPages
        ) {
          setCurrentPage(totalPages);
        }

        setNewRow({
          lane_guid: "",
          computername: "",
          laneid: "",
          placeid: "",
          placeName: "",
          barcodeType: "",
          discountType: "time",
        });
        setOpenAddRowDialog(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error adding new data:", error);
        setError("There was an error adding the new device. Please try again.");
      });
  };

  const handleToggleAddRowDialog = () => {
    setLanesOptions([]);
    if (!openAddRowDialog) {
      if (editBackup?.id) handleCancelEdit();
      newRow.lane_guid = generateUUID();
      setNewRow({ ...newRow });
    }
    setOpenAddRowDialog(!openAddRowDialog);
  };

  const totalPages = Math.ceil(webpayDevices.length / rowsPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      {isLoading ? (
        <div className="spinner"></div>
      ) : error ? (
        <div className="error-section">
          <strong>Error:</strong>
          <p>{error}</p>
        </div>
      ) : (
          <div style={{padding: "20px"}}>
          <span
              style={{
                display: "flex",
                justifyContent: "center",
                position: "fixed",
                top: 20,
                left: 0,
                right: 0,
                bottom: 0,
              }}
          >
            <h1>Webpay Devices</h1>
          </span>
            <TableContainer style={{padding: "20px"}} component={Paper}>
              <Table
                  size="small"
                  sx={{minWidth: 650, marginTop: 2}}
                  aria-label="simple table"
              >
                <TableHead sx={{marginTop: 40}}>
                  <TableRow>
                    {/* Reversed Searchable Input Fields in Header */}
                    <TableCell></TableCell>

                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search place id"
                          onChange={(e) =>
                              handleFilterChange("placeid", e.target.value)
                          }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search computer name"
                          onChange={(e) =>
                              handleFilterChange("computername", e.target.value)
                          }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField size="small" placeholder="Search lane guid"
                                 onChange={(e) => handleFilterChange("lane_guid", e.target.value)
                                 }/>
                    </TableCell>
                    <TableCell>
                      <TextField size="small" placeholder="Search prefix"
                                 onChange={(e) => handleFilterChange("allowedPrefixes", e.target.value)
                                 }/>
                    </TableCell>
                    <TableCell>
                      <TextField size="small" placeholder="Search grace time offset"
                                 onChange={(e) => handleFilterChange("graceTimeOffset", e.target.value)
                                 }/>
                    </TableCell>
                    <TableCell>
                    <TextField
                        size="small"
                        placeholder="Search payplus customer"
                        onChange={(e) =>
                            handleFilterChange("payplus_customer_name", e.target.value)
                        }
                    />
                  </TableCell>
                    <TableCell></TableCell>

                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search payment company"
                          onChange={(e) =>
                              handleFilterChange("paymentCompany", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search branch"
                          onChange={(e) =>
                              handleFilterChange("branchNum", e.target.value)
                          }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search override discount value"
                          onChange={(e) =>
                              handleFilterChange("overrideDiscountValue", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="override discount type"
                          onChange={(e) =>
                              handleFilterChange("overrideDiscountType", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search enable override"
                          onChange={(e) =>
                              handleFilterChange("enableOverride", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search payment discount"
                          onChange={(e) =>
                              handleFilterChange("payment_discount", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search payment on"
                          onChange={(e) =>
                              handleFilterChange("withPayment", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search qr on"
                          onChange={(e) =>
                              handleFilterChange("withQr", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search DiscountType"
                          onChange={(e) =>
                              handleFilterChange("discountType", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search Barcode Type"
                          onChange={(e) =>
                              handleFilterChange("barcodeType", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search Lane Name"
                          onChange={(e) =>
                              handleFilterChange("laneName", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search Place Name"
                          onChange={(e) =>
                              handleFilterChange("placeName", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search active"
                          onChange={(e) =>
                              handleFilterChange("active", e.target.value)
                          }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search Display Name"
                          onChange={(e) =>
                              handleFilterChange("displayName", e.target.value)
                          }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                          size="small"
                          placeholder="Search id"
                          onChange={(e) => handleFilterChange("id", e.target.value)}
                      />
                    </TableCell>
                    <TableCell></TableCell>

                  </TableRow>

                  <TableRow>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Delete
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                     Send Subscription
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Place ID
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Computer Name
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Lane GUID
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Allowed Pal Prefixes
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Grace Time Offset
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      {" "}
                      PayPlus Customer
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      {" "}
                      Open Discounts Table{" "}
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Payment Company
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Branch Number
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      override discount value
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      override discount type
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Enable override discount
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Payment Discount
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Enable Payment Flow
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Enable Qr Flow
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Discount Type
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Barcode Type
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Lane Name
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Place Name
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Active
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Display Name
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      ID
                    </TableCell>
                    <TableCell align="left" style={{fontWeight: "bold"}}>
                      Edit
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentDevices.map((row) => (
                      <TableRow key={row?.id}>
                        {editRow === row?.id ? (
                            <>
                              <TableCell align="left">
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                      setRowIdToBeDeleted(row?.id);
                                      setOpenDeleteDialog(true);
                                    }}
                                    style={{marginTop: "20px"}}
                                >
                                  Delete
                                </Button>
                              </TableCell>

                              <TableCell align="left">
                                <Button
                                    variant="contained"
                                    // color="error"
                                    onClick={() => {
                                      setRow(row);
                                      setIsOpenSendSubscriptionDialog(true);
                                    }}
                                    style={{marginTop: "20px"}}
                                >
                                  Send Subscription
                                </Button>
                              </TableCell>

                              <TableCell>
                                <TextField
                                    label="Place ID"
                                    fullWidth
                                    value={row.placeid}
                                    disabled
                                    InputProps={{
                                      readOnly: true,
                                      startAdornment: (
                                          <InputAdornment position="start">
                                            🔒
                                          </InputAdornment>
                                      ),
                                    }}
                                    error={isMaxLengthReached["placeid"]}
                                    helperText={
                                        isMaxLengthReached["placeid"] &&
                                        "Character limit reached"
                                    }
                                />
                              </TableCell>
                              <TableCell>
                                <TextField
                                    label="Computer Name"
                                    fullWidth
                                    value={row.computername}
                                    disabled
                                    InputProps={{
                                      readOnly: true,
                                      startAdornment: (
                                          <InputAdornment position="start">
                                            🔒
                                          </InputAdornment>
                                      ),
                                    }}
                                    error={isMaxLengthReached["computername"]}
                                    helperText={
                                        isMaxLengthReached["computername"] &&
                                        "Character limit reached"
                                    }
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                    label="Lane GUID"
                                    fullWidth
                                    value={row.lane_guid}
                                    disabled
                                    InputProps={{
                                      readOnly: true,
                                      startAdornment: (
                                          <InputAdornment position="start">
                                            🔒
                                          </InputAdornment>
                                      ),
                                    }}
                                />
                              </TableCell>
                              <TableCell>
                                <div style={{display: "flex", flexWrap: "wrap", gap: "8px"}}>
                                  {row?.allowedPrefixes?.map((prefix, index) => (
                                      <Chip
                                          key={index}
                                          label={prefix}
                                          onDelete={() => {
                                            // Remove it
                                            row.allowedPrefixes = row.allowedPrefixes.filter((_, i) => i !== index);
                                            setWebpayDevices([...webpayDevices]);
                                          }}
                                      />
                                  ))}
                                </div>
                                <TextField
                                    label="Add Prefix"
                                    value={newPrefix}
                                    style={{marginTop: "10px"}}
                                    onChange={(e) => setNewPrefix(e.target.value)}
                                />
                                <Button
                                    variant="contained"
                                    style={{marginTop: "10px"}}
                                    onClick={() => {
                                      if (newPrefix.trim()) {
                                        if (!row.allowedPrefixes)
                                          row.allowedPrefixes = [];
                                        row.allowedPrefixes = ([...row.allowedPrefixes, newPrefix.trim()]);
                                        setNewPrefix("");
                                        setWebpayDevices([...webpayDevices]);
                                      }
                                    }}
                                >
                                  Add
                                </Button>
                              </TableCell>
                              <TableCell>
                                <TextField
                                    label="Grace Time Offset"
                                    fullWidth
                                    type="number"
                                    value={row.graceTimeOffset}
                                    onChange={(e) => handleEditChange(e, "graceTimeOffset")}

                                />
                              </TableCell>
                              <TableCell align="left" style={{fontWeight: "bold"}}>
                                {/* For non-mobile (MUI Select) */}
                                <FormControl fullWidth>
                                  {!isMobile && <InputLabel>Payplus Client</InputLabel>}
                                  {!isMobile ? (
                                      <Select
                                          value={row?.payplus_customer_name || ""}
                                          onChange={(e) => {
                                            const selectedCustomerName = e.target.value;
                                            const selectedClient = payplus_clients.find(
                                                (client) => client.payplus_customer_name === selectedCustomerName
                                            );
                                            row.payplus_customer_name = selectedClient.payplus_customer_name;
                                            row.payplus_customer_email = selectedClient.payplus_customer_email;
                                            setWebpayDevices([...webpayDevices]);
                                          }}
                                          displayEmpty
                                          label="Payplus Client"
                                          style={{ textAlign: "left" }}
                                      >
                                        {payplus_clients.map((client) => (
                                            <MenuItem
                                                key={client.payplus_customer_email}
                                                value={client.payplus_customer_name} // Storing the entire object
                                            >
                                              {client.payplus_customer_name}
                                            </MenuItem>
                                        ))}
                                      </Select>
                                  ) : (
                                      // For mobile (native select), you cannot directly use objects as value.
                                      <select
                                          value={row?.payplus_customer_name || ""}
                                          onChange={(e) => {
                                            const selectedCustomerName = e.target.value;
                                            const selectedClient = payplus_clients.find(
                                                (client) => client.payplus_customer_name === selectedCustomerName
                                            );
                                            row.payplus_customer_name = selectedClient.payplus_customer_name;
                                            row.payplus_customer_email = selectedClient.payplus_customer_email;
                                            setWebpayDevices([...webpayDevices]);
                                          }}
                                          style={{ textAlign: "left", width: "100%", padding: "8px" }}
                                      >
                                        <option value="" disabled>
                                          Select payplus client
                                        </option>
                                        {payplus_clients.map((client) => (
                                            <option
                                                key={client.payplus_customer_email}
                                                value={client.payplus_customer_email}
                                            >
                                              {client.payplus_customer_name}
                                            </option>
                                        ))}
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell align="left" style={{fontWeight: "bold"}}>
                                <Button
                                    disabled={row.barcodeType !== "shufersal"}
                                    variant="outlined"
                                    onClick={() => {
                                      setCurrentPlaceId(row.placeid);
                                      setIsOpenDiscountsTable(true);
                                    }}
                                >
                                  {" "}
                                  Open Discounts Table
                                </Button>{" "}
                              </TableCell>

                              <TableCell align="left" style={{fontWeight: "bold"}}>
                                <FormControl fullWidth>
                                  {!isMobile ? <InputLabel>Payment Company</InputLabel> : null}

                                  {!isMobile ? (
                                      <Select
                                          value={
                                            row?.paymentCompany
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "paymentCompany")
                                          }
                                          displayEmpty
                                          label="payment company"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="payplus">payplus</MenuItem>
                                        <MenuItem value="tranzila">tranzila</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={
                                            row?.paymentCompany
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "paymentCompany")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select payment company
                                        </option>
                                        <option value="payplus">payplus</option>
                                        <option value="tranzila">tranzila</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <TextField
                                    label="Branch Number"
                                    fullWidth
                                    value={row.branchNum}
                                    onChange={(e) => handleEditChange(e, "branchNum")}
                                    error={isMaxLengthReached["branchNum"]}
                                    helperText={
                                        isMaxLengthReached["branchNum"] &&
                                        "Character limit reached"
                                    }
                                />
                              </TableCell>


                              <TableCell>
                                <TextField
                                    label="override discount value"
                                    fullWidth
                                    value={row.overrideDiscountValue}
                                    type="number"
                                    inputProps={{
                                      min: 0,
                                      step: 1, // Optional: use 'any' if you allow decimals
                                    }}
                                    style={{minWidth: "80px"}}
                                    onChange={(e) => handleEditChange(e, "overrideDiscountValue")}

                                />
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>Override Discount Type</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={row.overrideDiscountType}
                                          onChange={(e) =>
                                              handleEditChange(e, "overrideDiscountType")
                                          }
                                          displayEmpty
                                          label="overrided Discount Type"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="time">Time</MenuItem>
                                        <MenuItem value="amount">Amount</MenuItem>
                                        <MenuItem value="percentage">
                                          Percentage
                                        </MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={row.overrideDiscountType}
                                          onChange={(e) =>
                                              handleEditChange(e, "overrideDiscountType")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select overrided discount type
                                        </option>
                                        <option value="time">Time</option>
                                        <option value="amount">Amount</option>
                                        <option value="percentage">Percentage</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>Enable Override discount</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={
                                            row?.enableOverride === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "enableOverride")
                                          }
                                          displayEmpty
                                          label="enable override disocunt"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={
                                            row?.enableOverride === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "enableOverride")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select if override discount is on
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <TextField
                                    label="payment discount"
                                    fullWidth
                                    value={row.payment_discount}
                                    type="number"
                                    inputProps={{
                                      min: 0,
                                      step: 1, // Optional: use 'any' if you allow decimals
                                    }}
                                    style={{minWidth: "80px"}}
                                    onChange={(e) => handleEditChange(e, "payment_discount")}

                                />
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>is payment flow on</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={
                                            row?.withPayment === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "withPayment")
                                          }
                                          displayEmpty
                                          label="enable payment"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={
                                            row?.withPayment === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "withPayment")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select payment flow is on
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>is qr flow on</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={
                                            row?.withQr === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "withQr")
                                          }
                                          displayEmpty
                                          label="enable qr"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={
                                            row?.withQr === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) =>
                                              handleEditChange(e, "withQr")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select qr is on
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>Discount Type</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={row.discountType}
                                          onChange={(e) =>
                                              handleEditChange(e, "discountType")
                                          }
                                          displayEmpty
                                          label="Discount Type"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="time">Time</MenuItem>
                                        <MenuItem value="amount">Amount</MenuItem>
                                        <MenuItem value="percentage">
                                          Percentage
                                        </MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={row.discountType}
                                          onChange={(e) =>
                                              handleEditChange(e, "discountType")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select discount type
                                        </option>
                                        <option value="time">Time</option>
                                        <option value="amount">Amount</option>
                                        <option value="percentage">Percentage</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>Barcode Type</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={row.barcodeType}
                                          onChange={(e) =>
                                              handleEditChange(e, "barcodeType")
                                          }
                                          displayEmpty
                                          label="Barcode Type"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="rami levy">rami levy</MenuItem>
                                        <MenuItem value="shufersal">shufersal</MenuItem>
                                        <MenuItem value="comax">comax</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={row.barcodeType}
                                          onChange={(e) =>
                                              handleEditChange(e, "barcodeType")
                                          }
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select barcode type
                                        </option>
                                        <option value="rami levy">rami levy</option>
                                        <option value="shufersal">shufersal</option>
                                        <option value="comax">comax</option>

                                      </select>
                                  )}
                                  {(row?.barcodeType === 'comax' ) && (
                                      <Button
                                          variant="outlined"
                                          size="small"
                                          sx={{ mt: 2 }}
                                          onClick={()=>{handleOpenComaxSettings(row.placeid); setCurrentPlaceId(row.placeid)}}
                                      >
                                        OPEN DISCOUNT SETTINGS
                                      </Button>
                                  )}
                                </FormControl>
                              </TableCell>

                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel shrink={true}>Lane Name</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={row.laneid}
                                          onChange={(e) => handleEditChange(e, "laneid")}
                                          label="Lane Name"
                                          displayEmpty
                                          style={{textAlign: "left"}}
                                      >
                                        {lanesOptions?.map((lane) => (
                                            <MenuItem value={lane?.id}>
                                              {lane?.name}
                                            </MenuItem>
                                        ))}
                                      </Select>
                                  ) : (
                                      <select
                                          value={row.laneid}
                                          onChange={(e) => handleEditChange(e, "laneid")}
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          Select lane
                                        </option>
                                        {lanesOptions?.map((lane) => (
                                            <option key={lane?.id} value={lane?.id}>
                                              {lane?.name}
                                            </option>
                                        ))}
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                              <AsyncSearchField
                                  // style={{marginTop: "20px"}}
                                  value={row.placeName}
                                  onValueChange={(pName, pId) => {
                                    row.placeName = pName;
                                    row.placeid = pId;
                                    setWebpayDevices([...webpayDevices]);
                                    fetchPlaceInfo(row);
                                  }}
                              />{" "}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <FormControl fullWidth>
                                  {!isMobile ? (
                                      <InputLabel>is active</InputLabel>
                                  ) : null}
                                  {!isMobile ? (
                                      <Select
                                          value={row?.active === 1 ? "Yes" : "No"}
                                          onChange={(e) => handleEditChange(e, "active")}
                                          displayEmpty
                                          label="is active"
                                          style={{textAlign: "left"}}
                                      >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                      </Select>
                                  ) : (
                                      <select
                                          value={
                                            row?.active === 1 ? "Yes" : "No"
                                          }
                                          onChange={(e) => handleEditChange(e, "active")}
                                          style={{
                                            textAlign: "left",
                                            width: "100%",
                                            padding: "8px",
                                          }}
                                      >
                                        <option value="" disabled>
                                          select if active
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                      </select>
                                  )}
                                </FormControl>
                              </TableCell>
                              <TableCell>
                                <TextField
                                    value={row.displayName}
                                    label="Display Name"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={(e) => handleEditChange(e, "displayName")}
                                    error={isMaxLengthReached["displayName"]}
                                    helperText={
                                        isMaxLengthReached["displayName"] &&
                                        "Character limit reached"
                                    }
                                />
                              </TableCell>
                              <TableCell>{row?.id}</TableCell>
                              <TableCell>
                                <Button
                                    disabled={Object.values(
                                        isMaxLengthReached,
                                    ).includes(true)}
                                    variant="contained"
                                    onClick={handleSaveEdit}
                                >
                                  Save
                                </Button>
                                <Button
                                    style={{marginTop: 10, backgroundColor: "red"}}
                                    variant="contained"
                                    onClick={handleCancelEdit}
                                >
                                  Cancel
                                </Button>
                              </TableCell>
                            </>
                        ) : (
                            <>
                              <Button
                                  variant="contained"
                                  color="error"
                                  onClick={() => {
                                    setRowIdToBeDeleted(row?.id);
                                    setOpenDeleteDialog(true);
                                  }}
                                  style={{marginTop: "20px"}}
                              >
                                Delete
                              </Button>
                              <TableCell align="left">
                                <Button
                                    variant="contained"
                                    // color="error"
                                    onClick={() => {
                                      setRow(row);
                                      setIsOpenSendSubscriptionDialog(true);
                                    }}
                                    style={{marginTop: "20px"}}
                                >
                                  Send Subscription
                                </Button>
                              </TableCell>

                              <TableCell>{row?.placeid}</TableCell>
                              <TableCell>{row?.computername}</TableCell>
                              <TableCell>{row?.lane_guid}</TableCell>
                              <TableCell>
                                <div style={{display: "flex", flexWrap: "wrap", gap: "8px"}}>
                                  {row?.allowedPrefixes?.map((prefix, index) => (
                                      <Chip
                                          key={index}
                                          label={prefix}
                                          // onDelete={() => {
                                          //   // Remove it
                                          //   row.allowedPrefixes = row.allowedPrefixes.filter((_, i) => i !== index);
                                          //   setWebpayDevices([...webpayDevices]);
                                          // }}
                                      />
                                  ))}
                                </div>
                              </TableCell>
                              <TableCell>
                                {row?.graceTimeOffset} minutes
                              </TableCell>
                              <TableCell>
                                 {row?.payplus_customer_name}
                              </TableCell>
                              <TableCell align="left" style={{fontWeight: "bold"}}>
                                <Button
                                    disabled={row?.barcodeType !== "shufersal"}
                                    variant="outlined"
                                    onClick={() => {
                                      setCurrentPlaceId(row.placeid);
                                      setIsOpenDiscountsTable(true);
                                    }}
                                >
                                  {" "}
                                  Open Discounts Table
                                </Button>{" "}
                              </TableCell>
                              <TableCell>{row?.paymentCompany}</TableCell>
                              <TableCell>{row?.branchNum}</TableCell>
                              <TableCell>
                                {row?.overrideDiscountValue}
                              </TableCell>
                              <TableCell>
                                {row?.overrideDiscountType}
                              </TableCell>

                              <TableCell>
                                {row?.enableOverride === 1 ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>
                                {row?.payment_discount}
                              </TableCell>
                              <TableCell>
                                {row?.withPayment === 1 ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>
                                {row?.withQr === 1 ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>
                                {row?.barcodeType === "shufersal"
                                    ? "check discount table"
                                    : row?.discountType}
                              </TableCell>
                              <TableCell>{row?.barcodeType}</TableCell>
                              <TableCell>{row?.laneName}</TableCell>
                              <TableCell>{row?.placeName}</TableCell>
                              <TableCell>
                                {row?.active === 1 ? "Yes" : "No"}
                              </TableCell>
                              <TableCell>{row?.displayName}</TableCell>
                              <TableCell>{row?.id}</TableCell>
                              <TableCell>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                      setEditBackup({...row});
                                      setEditRow(row.id);
                                      fetchPlaceInfo(row);
                                    }}
                                >
                                  Edit
                                </Button>
                              </TableCell>
                            </>
                        )}
                      </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box display="flex" justifyContent="center" mt={2}>
              <FormControl>
                <InputLabel>Page</InputLabel>
                <Select
                    MenuProps={{
                      disablePortal: true, // Renders menu in the same DOM hierarchy
                    }}
                    value={currentPage}
                    onChange={handlePageChange}
                    label="Page"
                >
                  {pageNumbers.map((page) => (
                      <MenuItem key={page} value={page}>
                        {page}
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Button
                sx={{
                  position: {xs: "fixed", md: "static"},
                  bottom: {xs: "15%"},
                  left: {xs: "60%"},
                  transform: {xs: "translate(-50%, -75%)"},
                }}
                variant="contained"
                onClick={handleToggleAddRowDialog}
            >
              {openAddRowDialog ? "Cancel" : "Add Device"}
            </Button>

            <Dialog
                open={comaxSettingsOpen}
                onClose={handleCloseComaxSettings}
                fullWidth
                maxWidth="sm"
            >
              <DialogTitle>Comax Discount Settings</DialogTitle>
              <DialogContent>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Discount Type</TableCell>
                      <TableCell>Discount Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Select
                            fullWidth
                            value={comaxSettings.discountType}
                            onChange={(e) =>
                                setComaxSettings((prev) => prev && {
                                  ...prev,
                                  discountType: e.target.value
                                })
                            }
                        >
                          <MenuItem value="time">Time</MenuItem>
                          <MenuItem value="amount">Amount</MenuItem>
                          <MenuItem value="percentage">Percentage</MenuItem>
                        </Select>
                      </TableCell>
                      <TableCell>
                        <TextField
                            fullWidth
                            type="number"
                            value={comaxSettings.discountVal}
                            onChange={(e) =>
                                setComaxSettings((prev) => prev && {
                                  ...prev,
                                  discountVal: Number(e.target.value)
                                })
                            }
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseComaxSettings}>Cancel</Button>
                <Button onClick={handleSaveComaxSettings} color="primary">
                  Save
                </Button>
              </DialogActions>
            </Dialog>


            <Dialog
                fullWidth={isMobile} // Full-screen only on mobile devices
                PaperProps={
                    isMobile && {
                      style: {
                        margin: 0,
                        position: "fixed",
                        top: "25%",
                        left: "90%",
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "90%" : "400px",
                      },
                    }
                }
                size="sm"
                open={openAddRowDialog}
                onClose={handleToggleAddRowDialog}
            >
              <DialogTitle>
              <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
              >
                Add New Device
              </span>
              </DialogTitle>
              <DialogContent
                  style={{
                    textAlign: "center",
                    minHeight: isMobile ? "100vh" : "auto",
                    minWidth: isMobile ? "100vw" : "auto",
                  }}
              >

                <FormControl fullWidth style={{marginTop: 15}}>
                  <TextField
                      value={newRow.displayName}
                      label="Display Name"
                      onChange={(e) => handleEditNewField(e, "displayName")}
                      error={isMaxLengthReachedNewRow["displayName"]}
                      helperText={
                          isMaxLengthReachedNewRow["displayName"] &&
                          "Character limit reached"
                      }
                  />
                </FormControl>
                <AsyncSearchField
                    isCreateNew={true}
                    style={{marginTop: "25px"}}
                    value={newRow.placeName}
                    onValueChange={(pName, pId) => {
                      newRow.placeName = pName;
                      newRow.placeid = pId;
                      setNewRow({...newRow});
                    }}
                />
                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Active</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          MenuProps={{
                            disablePortal: true, // Renders menu in the same DOM hierarchy
                          }}
                          style={{textAlign: "left"}}
                          label="Active"
                          value={newRow.active === 1 ? "Yes" : "No"}
                          onChange={(e) =>
                              setNewRow({
                                ...newRow,
                                active: e.target.value === "Yes" ? 1 : 0,
                              })
                          }
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={newRow.active === 1 ? "Yes" : "No"}
                          onChange={(e) =>
                              setNewRow({
                                ...newRow,
                                active: e.target.value === "Yes" ? 1 : 0,
                              })
                          }
                          style={{textAlign: "left", width: "100%", padding: "8px"}}
                      >
                        <option value="" disabled>
                          is active
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                  )}
                </FormControl>
                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Lane Name</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          value={newRow.laneid}
                          onChange={(e) => handleEditNewField(e, "laneid")}
                          label="Lane Name"
                          style={{textAlign: "left"}}
                      >
                        {lanesOptions?.map((lane) => (
                            <MenuItem value={lane?.id}>{lane?.name}</MenuItem>
                        ))}
                      </Select>
                  ) : (
                      <select
                          value={newRow.laneid}
                          onChange={(e) => handleEditNewField(e, "laneid")}
                          style={{textAlign: "left", width: "100%", padding: "8px"}} // Optional inline styling
                      >
                        <option value="" disabled>
                          Select lane
                        </option>
                        {lanesOptions?.map((lane) => (
                            <option key={lane?.id} value={lane?.id}>
                              {lane?.name}
                            </option>
                        ))}
                      </select>
                  )}
                </FormControl>

                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Barcode Type</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          MenuProps={{
                            disablePortal: true, // Renders menu in the same DOM hierarchy
                          }}
                          value={newRow.barcodeType}
                          onChange={(e) => handleEditNewField(e, "barcodeType")}
                          displayEmpty
                          label="Barcode Type"
                          style={{textAlign: "left"}}
                      >
                        <MenuItem value="rami levy">rami levy</MenuItem>
                        <MenuItem value="shufersal">shufersal</MenuItem>
                        <MenuItem value="comax">comax</MenuItem>

                      </Select>
                  ) : (
                      <select
                          value={newRow.barcodeType}
                          onChange={(e) => handleEditNewField(e, "barcodeType")}
                          style={{textAlign: "left", width: "100%", padding: "8px"}}
                      >
                        <option value="" disabled>
                          Select barcode type
                        </option>
                        <option value="rami levy">rami levy</option>
                        <option value="shufersal">shufersal</option>
                        <option value="comax">comax</option>

                      </select>
                  )}
                  {(newRow.barcodeType === 'comax') && (
                      <Button
                          variant="outlined"
                          size="small"
                          sx={{ mt: 2 }}
                          onClick={()=>{handleOpenComaxSettings(newRow.placeid); setCurrentPlaceId(newRow.placeid)}}
                        >
                        OPEN DISCOUNT SETTINGS
                      </Button>
                  )}
                </FormControl>
                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Discount Type</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          MenuProps={{
                            disablePortal: true, // Renders menu in the same DOM hierarchy
                          }}
                          value={newRow.discountType}
                          style={{textAlign: "left"}}
                          label="Discount Type"
                          onChange={(e) =>
                              setNewRow({...newRow, discountType: e.target.value})
                          }
                      >
                        <MenuItem value="time">Time</MenuItem>
                        <MenuItem value="amount">Amount</MenuItem>
                        <MenuItem value="percentage">Percentage</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={newRow.discountType}
                          onChange={(e) =>
                              setNewRow({...newRow, discountType: e.target.value})
                          }
                          style={{textAlign: "left", width: "100%", padding: "8px"}}
                      >
                        <option value="" disabled>
                          Select Discount Type
                        </option>
                        <option value="time">Time</option>
                        <option value="amount">Amount</option>
                        <option value="percentage">Percentage</option>
                      </select>
                  )}
                </FormControl>
                <TextField
                    label="Branch Number"
                    fullWidth
                    value={newRow.branchNum}
                    onChange={(e) => handleEditNewField(e, "branchNum")}
                    style={{marginTop: 15}}
                    error={isMaxLengthReachedNewRow["branchNum"]}
                    helperText={
                        isMaxLengthReachedNewRow["branchNum"] &&
                        "Character limit reached"
                    }
                />
                  <TextField
                      label="payment discount"
                      fullWidth
                      value={newRow.payment_discount}
                      type="number"
                      inputProps={{
                        min: 0,
                        step: 1, // Optional: use 'any' if you allow decimals
                      }}
                      style={{minWidth: "80px", marginTop: 15}}
                      onChange={(e) => handleEditNewField(e, "payment_discount")}

                  />
                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? (
                      <InputLabel>is payment flow on</InputLabel>
                  ) : null}
                  {!isMobile ? (
                      <Select
                          value={
                            newRow?.withPayment === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "withPayment")
                          }
                          displayEmpty
                          label="enable payment"
                          style={{textAlign: "left"}}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={
                            newRow?.withPayment === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "withPayment")
                          }
                          style={{
                            textAlign: "left",
                            width: "100%",
                            padding: "8px",
                          }}
                      >
                        <option value="" disabled>
                          Select is payment flow on
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                  )}
                </FormControl>

                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? (
                      <InputLabel>is qr flow on</InputLabel>
                  ) : null}
                  {!isMobile ? (
                      <Select
                          value={
                            newRow?.withQr === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "withQr")
                          }
                          displayEmpty
                          label="enable qr"
                          style={{textAlign: "left"}}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={
                            newRow?.withQr === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "withQr")
                          }
                          style={{
                            textAlign: "left",
                            width: "100%",
                            padding: "8px",
                          }}
                      >
                        <option value="" disabled>
                          Select qr flow is on
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                  )}
                </FormControl>

                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? (
                      <InputLabel>Enable Override discount</InputLabel>
                  ) : null}
                  {!isMobile ? (
                      <Select
                          value={
                            newRow?.enableOverride === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "enableOverride")
                          }
                          displayEmpty
                          label="enable override disocunt"
                          style={{textAlign: "left"}}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={
                            newRow?.enableOverride === 1 ? "Yes" : "No"
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "enableOverride")
                          }
                          style={{
                            textAlign: "left",
                            width: "100%",
                            padding: "8px",
                          }}
                      >
                        <option value="" disabled>
                          Select if override discount is on
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                  )}
                </FormControl>

                  <TextField
                      label="override discount value"
                      fullWidth
                      value={newRow.overrideDiscountValue}
                      type="number"
                      style={{minWidth: "80px", marginTop: 15}}
                      onChange={(e) => handleEditNewField(e, "overrideDiscountValue")}

                  />
                  <FormControl fullWidth style={{marginTop: 15}}>
                    {!isMobile ? (
                        <InputLabel>Override Discount Type</InputLabel>
                    ) : null}
                    {!isMobile ? (
                        <Select
                            value={newRow.overrideDiscountType}
                            onChange={(e) =>
                                handleEditNewField(e, "overrideDiscountType")
                            }
                            displayEmpty
                            label="overrided Discount Type"
                            style={{textAlign: "left"}}
                        >
                          <MenuItem value="time">Time</MenuItem>
                          <MenuItem value="amount">Amount</MenuItem>
                          <MenuItem value="percentage">
                            Percentage
                          </MenuItem>
                        </Select>
                    ) : (
                        <select
                            value={newRow.overrideDiscountType}
                            onChange={(e) =>
                                handleEditNewField(e, "overrideDiscountType")
                            }
                            style={{
                              textAlign: "left",
                              width: "100%",
                              padding: "8px",
                            }}
                        >
                          <option value="" disabled>
                            Select overrided discount type
                          </option>
                          <option value="time">Time</option>
                          <option value="amount">Amount</option>
                          <option value="percentage">Percentage</option>
                        </select>
                    )}
                  </FormControl>
                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Payment Company</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          value={
                            newRow?.paymentCompany
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "paymentCompany")
                          }
                          displayEmpty
                          label="payment company"
                          style={{textAlign: "left"}}
                      >
                        <MenuItem value="payplus">payplus</MenuItem>
                        <MenuItem value="tranzila">tranzila</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={
                            newRow?.paymentCompany
                          }
                          onChange={(e) =>
                              handleEditNewField(e, "paymentCompany")
                          }
                          style={{
                            textAlign: "left",
                            width: "100%",
                            padding: "8px",
                          }}
                      >
                        <option value="" disabled>
                          Select payment company
                        </option>
                        <option value="payplus">payplus</option>
                        <option value="tranzila">tranzila</option>
                      </select>
                  )}
                </FormControl>

                <FormControl fullWidth style={{marginTop: 15}}>
                  {!isMobile ? <InputLabel>Full Discount</InputLabel> : null}
                  {!isMobile ? (
                      <Select
                          MenuProps={{
                            disablePortal: true, // Renders menu in the same DOM hierarchy
                          }}
                          style={{textAlign: "left"}}
                          label="Full Discount"
                          value={newRow.isFullDiscountOn === 1 ? "Yes" : "No"}
                          onChange={(e) =>
                              setNewRow({
                                ...newRow,
                                isFullDiscountOn: e.target.value === "Yes" ? 1 : 0,
                              })
                          }
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                  ) : (
                      <select
                          value={newRow.isFullDiscountOn === 1 ? "Yes" : "No"}
                          onChange={(e) =>
                              setNewRow({
                                ...newRow,
                                isFullDiscountOn: e.target.value === "Yes" ? 1 : 0,
                              })
                          }
                          style={{textAlign: "left", width: "100%", padding: "8px"}}
                      >
                        <option value="" disabled>
                          Select full discount is on
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                  )}
                </FormControl>



                <div style={{display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "5px"}}>
                  {newRow?.allowedPrefixes?.map((prefix, index) => (
                      <Chip
                          key={index}
                          label={prefix}
                          onDelete={() => {
                            // Remove it
                            newRow.allowedPrefixes = newRow.allowedPrefixes.filter((_, i) => i !== index);
                          }}
                      />
                  ))}
                </div>
                <TextField
                    fullWidth
                    label="Add Prefix"
                    value={newPrefix}
                    style={{marginTop: 15}}
                    onChange={(e) => setNewPrefix(e.target.value)}
                />
                <Button
                    variant="contained"
                    style={{marginTop: "5px"}}
                    onClick={() => {
                      if (newPrefix.trim()) {
                        if (!newRow.allowedPrefixes)
                          newRow.allowedPrefixes = [];
                        newRow.allowedPrefixes = ([...newRow.allowedPrefixes, newPrefix.trim()]);
                        setNewPrefix("");
                      }
                    }}
                >
                  Add
                </Button>
                <TextField
                    label="Grace Time Offset"
                    fullWidth
                    type="number"
                    value={newRow.graceTimeOffset}
                    onChange={(e) => handleEditNewField(e, "graceTimeOffset")}

                />
                <TextField
                    label="Lane GUID"
                    fullWidth
                    value={newRow.lane_guid}
                    style={{marginTop: 15}}
                    disabled
                    InputProps={{
                      readOnly: true,
                      startAdornment: (
                          <InputAdornment position="start">🔒</InputAdornment>
                      ),
                    }}
                />
                <TextField
                    label="Computer Name"
                    fullWidth
                    value={newRow.computername}
                    disabled
                    InputProps={{
                      readOnly: true,
                      startAdornment: (
                          <InputAdornment position="start">🔒</InputAdornment>
                      ),
                    }}
                    style={{marginTop: 15}}
                    error={isMaxLengthReachedNewRow["computername"]}
                    helperText={
                        isMaxLengthReachedNewRow["computername"] &&
                        "Character limit reached"
                    }
                />
                <TextField
                    label="Place ID"
                    fullWidth
                    value={newRow.placeid}
                    style={{marginTop: 15}}
                    disabled
                    InputProps={{
                      readOnly: true,
                      startAdornment: (
                          <InputAdornment position="start">🔒</InputAdornment>
                      ),
                    }}
                    error={isMaxLengthReachedNewRow["placeid"]}
                    helperText={
                        isMaxLengthReachedNewRow["placeid"] &&
                        "Character limit reached"
                    }
                />
              </DialogContent>
              <DialogActions
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
              >
                <Button
                    style={{marginLeft: "20px"}}
                    variant="contained"
                    color="error"
                    onClick={handleToggleAddRowDialog}
                >
                  Cancel
                </Button>
                <Button
                    disabled={Object.values(isMaxLengthReachedNewRow).includes(
                        true,
                    )}
                    variant="contained"
                    onClick={handleAddNewRow}
                    color="primary"
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={isMobile}
                PaperProps={
                    isMobile && {
                      style: {
                        margin: 0,
                        position: "fixed",
                        top: "25%",
                        left: "90%",
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "90%" : "400px",
                      },
                    }
                }
                size="sm"
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
            >
              <DialogTitle>
              <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
              >
                Delete device
              </span>
              </DialogTitle>
              <DialogContent>
                <span>?Are you sure you want to delete the device</span>
                <div>.the device will be deleted permanently</div>
                <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                >
                  <Button
                      color="primary"
                      style={{marginLeft: "10px"}}
                      variant="contained"
                      onClick={() => setOpenDeleteDialog(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                      color="error"
                      variant="contained"
                      onClick={() => {
                        handleDelete(rowIdToBeDeleted);
                        setOpenDeleteDialog(false);
                      }}
                  >
                    Delete
                  </Button>
                </div>
              </DialogContent>
            </Dialog>

            <Dialog
                fullWidth={isMobile} // Full-screen only on mobile devices
                PaperProps={
                    isMobile && {
                      style: {
                        margin: 0,
                        position: "fixed",
                        top: "25%",
                        left: "90%",
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "90%" : "400px",
                      },
                    }
                }
                size="sm"
                open={isOpenSendSubscriptionDialog}
                onClose={()=> setIsOpenSendSubscriptionDialog(false)}
            >
              <DialogTitle>
              <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
              >
                Send Subscription Amount
              </span>
              </DialogTitle>
              <DialogContent
                  style={{
                    textAlign: "center",
                    minHeight: isMobile ? "100vh" : "auto",
                    minWidth: isMobile ? "100vw" : "auto",
                  }}
              >

                <FormControl fullWidth style={{marginTop: 15}}>
                  <TextField
                      value={subscriptionAmount}
                      label="Subscription Amount"
                      onChange={(e) => setSubscriptionAmount(e.target.value)}
                      type={"number"}
                  />
                  <TextField
                      value={carNum}
                      label="Car Number"
                      sx={{mt: 2}}
                      onChange={(e) => setCarNum(e.target.value)}
                      type={"text"}
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>setIsOpenSendSubscriptionDialog(false)}>Cancel</Button>
                <Button onClick={handleSendSubsriptionAmount} color="primary">
                  Save
                </Button>
              </DialogActions>
            </Dialog>

            <div style={{maxWidth: "1200px"}}>
              <Dialog
                  fullWidth={isMobile}
                  sx={{
                    "& .MuiDialog-paper": {
                      maxWidth: "1200px", // Set max-width here
                    },
                  }}
                  PaperProps={
                      isMobile && {
                        style: {
                          margin: 0,
                          position: "fixed",
                          top: "25%",
                          left: "90%",
                          transform: "translate(-30%, -50%)",
                          width: isMobile ? "90%" : "400px",
                        },
                      }
                  }
                  size="sm"
                  open={isOpenDiscountsTable}
                  onClose={() => setIsOpenDiscountsTable(false)}
              >
                <DialogTitle>
                <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                >
                  Edit Discounts Codes
                </span>
                </DialogTitle>
                <DialogContent>
                  <DiscountsTable placeId={currentPlaceId}/>
                </DialogContent>
              </Dialog>
            </div>
            <div style={{maxWidth: "1200px"}}>
            </div>
          </div>
      )}
    </div>
  );
}

export default Management;
